/* src/app/shared/controls/wizard-control/wizard-control.component.scss */
.wizard-control {
  display: flex;
  width: 99.8%;
  border-style: solid;
  border-top-width: 0;
  border-bottom-width: 3px;
  border-left-width: 0;
  border-right-width: 0;
  border-color: #1b638b;
  align-items: flex-end;
  cursor: pointer;
  color: #000000;
  background: rgb(242.25, 242.25, 242.25);
  border-style: solid;
  border-width: 1px;
  border-color: rgb(222.25, 222.25, 222.25);
  border-top-left-radius: 10px;
  border-bottom-left-radius: 2px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 2px;
  border-style: solid;
  border-top-width: 0;
  border-bottom-width: 3px;
  border-left-width: 0;
  border-right-width: 0;
  border-color: #1b638b;
}
.wizard-control .step {
  display: flex;
  align-items: center;
  padding: 10px 20px;
  position: relative;
}
.wizard-control .step:first-child {
  border-top-left-radius: 10px;
}
.wizard-control .step .step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 10pt;
  font-weight: bold;
  color: rgb(242.25, 242.25, 242.25);
  background-color: #1b638b;
  border-color: rgb(222.25, 222.25, 222.25);
  border-radius: 12.5px;
  width: 25px;
  height: 25px;
  margin-right: 7px;
}
.wizard-control .step.active {
  background: #1b638b;
  color: #ffffff;
  border-color: #1b638b;
  border-top-right-radius: 30px;
  border-bottom-right-radius: 30px;
}
.wizard-control .step.active .step-icon {
  color: #006f8a;
  background-color: rgb(242.25, 242.25, 242.25);
}
.wizard-control .step.completed {
  background: #1b638b;
  color: #ffffff;
  border-color: #1b638b;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
.wizard-control .step.completed .step-icon {
  color: #1b638b;
  background-color: rgb(242.25, 242.25, 242.25);
}
.wizard-container {
  width: 98%;
  margin-top: 10px;
  padding: 20px;
  padding-top: 10px;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(222.25, 222.25, 222.25);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.wizard-buttons {
  width: 98%;
  padding: 20px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-style: solid;
  border-width: 1px;
  border-color: rgb(222.25, 222.25, 222.25);
  border-top-style: none;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.wizard-buttons .action-bar button {
  margin-inline-end: 5px;
}
.wizard-buttons .action-bar button.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
  border-color: rgba(0, 0, 0, 0.2);
}
/*# sourceMappingURL=wizard-control.component-Y7VROF3J.css.map */
